import React from 'react';
import MenuItem from './MenuItem';

const ManageNeighbors: React.FC = () => {
  return <MenuItem label="내 이웃 관리" />;
};

export default ManageNeighbors;